/***
 * Created on 2023/8/18
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect, useRef, useState} from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useCaptcha} from "../../../hook/captcha";
import {getPrimaryPhone} from "../../../service/user";
import {useCountdown} from "../../common/countdown";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {apiDelete, apiGet, apiPost} from "../../../service/api";

function ConfirmDeleteDialog(props) {
    const { t } = useTranslation();
    const {Captcha, hasCaptcha, captchaValue, captchaError} = useCaptcha();
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const {phone, country_code} = getPrimaryPhone(currentUser);
    const [code, setCode] = useState("");
    const modalRef = useRef();
    const {seconds, setSeconds} = useCountdown(60);
    const queryClient = useQueryClient();

    const checkWarningInput = [
        t('@Your purchased SSL certificate licenses on myQNAPcloud will be deleted.@'),
        t('@All your devices registered under this account will be deleted.@'),
        t('@You will nolonger have myQNAPcloud remote access services to all your devices.@'),
        t('@All the existing myQNAPcloud sharing links will become invalid.@'),
        t('@You will not recieve notification on your paired mobile devices.@'),
        t('@All of the contacts associated with this account will be deleted.@'),
        t('@Your files and folders in myQNAPcloud Storage will be permanently deleted.@')
    ];

    const validate = () => {
        const allCheckbox = document.querySelectorAll('input[type=checkbox]');
        const checked = document.querySelectorAll('input[type=checkbox]:checked');
        const allChecked = allCheckbox.length === checked.length;
        modalRef.current.disableSubmitButton( !( allChecked && (props.metadata.method === 'phone' && code.length === 6) ));
    }

    useQuery({
        queryKey: ['get_countdown'],
        queryFn: async () => {
            const data = await apiGet('/ajax/countdown');
            const now = new Date().getTime();
            const value = Math.round((now - data?.countdown) / 1000) || 0;
            setSeconds(value > 60 ? 0 : 60 - value);
            return data;
        }
    });

    const resendMutate = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/resend_mobile_revoke_code', data),
        onSuccess: data => {
            queryClient.invalidateQueries({
                queryKey: ['get_countdown']
            })
        },
        onError: (error, variables, context) => {
            console.log(error);
        }
    });

    const onResend = async () => {
        await resendMutate.mutateAsync();
    }

    const confirmMutation = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/verify_mobile', data),
        onSuccess: data => {
            location.href = '/delete-qid-success';
        },
        onError: (error, variables, context) => {

        }
    });

    const onConfirmDelete = async () => {
        const data = {
            code,
            captcha: captchaValue
        }
        await confirmMutation.mutateAsync(data);
    }

    useEffect(() => {
        validate();
    }, [code]);


    return (
        <ModalDialog {...props} title={t('@Permanently Delete Account@')} submitText={t('@Confirm@')} ref={modalRef} submitAction={async ()=> await onConfirmDelete()}>
            <div className="dialog-content">
                {props.metadata.method === 'phone' &&
                    <>
                        <div className="dialog__form-group">
                            <label>{t('@The SMS has been sent to@')}</label>
                            <div className="comp-input">
                                <div className="input-field--hybrid">
                                    <input type="text" value={`(${country_code}) ${phone}`} disabled />
                                    <button className="q-btn q-btn-default" disabled={seconds>0} onClick={async e => await onResend()}>
                                        {t('@Resend@')} {seconds <= 0 ? "" : `(${seconds})`}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="dialog__form-group">
                            <label>{t('@Please check your SMS and enter the verification code in the box below@')}</label>
                            <input type="text" className="w-full max-w-full input--must-fill" value={code} onChange={(e)=>setCode(e.target.value)}/>
                        </div>

                        {hasCaptcha && Captcha }
                    </>
                }
                <div className="dialog__form-group !mb-0">
                    <label>{t('@Please note the following@')}</label>
                    <div className="dialog__info-grid !mb-0">
                        {
                            checkWarningInput.map((e, i) => (
                                <div className="info-grid__row pt-8 pr-16 pb-8 pl-16" key={i}>
                                    <div className="comp-checkbox">
                                        <label className="q-checkbox">
                                            <input type="checkbox" name={`checkbox-checked-${i}`} onClick={validate}/>
                                            <span>{e}</span>
                                        </label>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </ModalDialog>
    );
}

export default ConfirmDeleteDialog;